export default __webpack_public_path__ + "static/media/voiceRecorderSolution.d9e93968.png";